import React, { useEffect, useState } from 'react';

import { Card, Button, Modal, Accordion } from 'react-bootstrap';
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ResourceTypes.scss';
import PageTable from '../../Shared/PageTable/PageTable';
import Field from '../../Shared/Wizard/Field/Field';

function ResourceTypes(props) {
    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const availableMaintenanceRules = [
        { label: t("resourcetypes.cleaning_rules.rules.moveout"), value: "moveout" },
        { label: t("resourcetypes.cleaning_rules.rules.bathroomtuesday"), value: "bathroomtuesday" },
        { label: t("resourcetypes.cleaning_rules.rules.bathroomwednesday"), value: "bathroomwednesday" },
        { label: t("resourcetypes.cleaning_rules.rules.givenday"), value: "givenday" },
        { label: t("resourcetypes.cleaning_rules.rules.mondaycleaning"), value: "mondaycleaning" }
    ];

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });

    const [editResourcetype, setEditResourcetype] = useState({
        name: "",
        autoGenerateTimeline:false,
        resourceSubtype: "",
        defaultProps: [""],
    } as any);

    const [deleteResourcetype, setDeleteResourcetype] = useState({
        name: "",
        autoGenerateTimeline:false,
        resourceSubtype: "",
        defaultProps: [""],
    })
    
    const setEditResourcetypeName = value => { setEditResourcetype(editResource => ({ ...editResource, name: value })); }
    const setEditResourceSubtype = value => { setEditResourcetype(editResource => ({ ...editResource, resourceSubtype: value })) }
    const setEditResourcetypeDefaultProps = value => { setEditResourcetype(editResource => ({ ...editResource, defaultProps: value })); }
    const setEditAutoGenerateTimeline = value => { setEditResourcetype(editResource => ({ ...editResource, autoGenerateTimeline: value })); }
    const setEditResourcetypeMaintenanceRules = value => { setEditResourcetype(editResource => ({ ...editResource, maintenanceRules: value })); }

    const [newName, setNewName] = useState("");
    const [newResourceSubType, setNewResourceSubType] = useState<Array<any>>([]);
    const [newDefaultProps, setNewDefaultProps] = useState<Array<Object>>([]);
    const [newAutoGenerateTimeline, setAutoGenerateTimeline] = useState(false);
    const [newMaintenanceRules, setNewMaintenanceRules] = useState<Array<any>>([]);

    const [show, setShow] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [updateTable, setUpdateTable] = useState(0);

    function handleShow() {
        setShow(true);
    }
    function handleClose() {
        setShow(false);
        cleanNewForm();
    };

    const handleShowEditModal = (dataLine) => {
        setEditResourcetype(dataLine);
        setShowEditModal(true);
    }
    const handleCloseEditModal = () => setShowEditModal(false);

    const handleShowDeleteModal = (dataLine, evt) => {
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();
        setDeleteResourcetype(dataLine);
        setShowDeleteModal(true);
    }
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    function cleanNewForm() {
        setNewName("");
        setNewDefaultProps([]);
        setNewResourceSubType([]);
        setAutoGenerateTimeline(false);
    };

    const updateNewSubtypes = value => {
        let tempSubtypes = newResourceSubType;
        let values = value.split("\n");
        tempSubtypes = values;

        setNewResourceSubType(JSON.parse(JSON.stringify(tempSubtypes)))

    }

    const updateEditSubtypes = value => {
        let tempSubtypes = editResourcetype["resourceSubtype"];
        let values = value.split("\n");
        tempSubtypes = values;

        setEditResourceSubtype(JSON.parse(JSON.stringify(tempSubtypes)));
    }

    const addProp = () => {
        setNewDefaultProps([...newDefaultProps != undefined ? newDefaultProps : [], { name: "", value: "" }]);
    }

    const handleNewPropName = (val, key) => {
        let temp = newDefaultProps != undefined ? newDefaultProps : [];
        temp[key]["name"] = val;
        setNewDefaultProps(JSON.parse(JSON.stringify(temp)));
    }
    const handleNewPropValue = (val, key) => {
        let temp = newDefaultProps != undefined ? newDefaultProps : [];
        temp[key]["value"] = val;
        setNewDefaultProps(JSON.parse(JSON.stringify(temp)));
    }
    const deleteProp = (key) => {
        let temp = newDefaultProps;
        temp.splice(key, 1);
        setNewDefaultProps(JSON.parse(JSON.stringify(temp)));
    }

    const addEditProp = () => {
        setEditResourcetypeDefaultProps([...editResourcetype["defaultProps"] != undefined ? editResourcetype["defaultProps"] : [], { name: "", value: "" }]);
    }
    const handleEditPropName = (val, key) => {
        let temp = editResourcetype["defaultProps"] != undefined ? editResourcetype["defaultProps"] : [];
        temp[key]["name"] = val;
        setEditResourcetypeDefaultProps(JSON.parse(JSON.stringify(temp)));
    }
    const handleEditPropValue = (val, key) => {
        let temp = editResourcetype["defaultProps"] != undefined ? editResourcetype["defaultProps"] : [];
        temp[key]["value"] = val;
        setEditResourcetypeDefaultProps(JSON.parse(JSON.stringify(temp)));
    }
    const deleteEditProp = (key) => {
        let temp = editResourcetype["defaultProps"];
        temp.splice(key, 1);
        setEditResourcetypeDefaultProps(JSON.parse(JSON.stringify(temp)));
    }
    
    function handleUpdate(){
        if(props.onChange != undefined){
            props.onChange();
        }
    }
    
    function handleCreateResource() {
        if (newName == "") { notifyWarning(t("resourcetypes.toast_resourcetype_empty_name")); return undefined; }
        axios.post(
            "/api/resourcetypes/",
            {
                name: newName,
                resourceSubtype: newResourceSubType,
                defaultProps: newDefaultProps,
                autoGenerateTimeline: newAutoGenerateTimeline,
                maintenanceRules: newMaintenanceRules
            },
            {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            cleanNewForm();
            notifySuccess(t("resourcetypes.toast_resourcetype_created"));
            handleClose();
            setUpdateTable(updateTable + 1);
        });
        handleUpdate();
    };

    function handleEditResourcetype() {
        if (editResourcetype["name"] == "") { notifyWarning(t("resourcetypes.toast_resourcetype_empty_name")); return undefined; };
        axios.put(
            "/api/resourcetypes/" + editResourcetype["_id"],
            {
                name: editResourcetype["name"],
                resourceSubtype: editResourcetype["resourceSubtype"],
                defaultProps: editResourcetype["defaultProps"],
                autoGenerateTimeline: editResourcetype["autoGenerateTimeline"] != null ? editResourcetype["autoGenerateTimeline"] : undefined,
                maintenanceRules: editResourcetype["maintenanceRules"]
            },
            {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            handleCloseEditModal();
            setUpdateTable(updateTable + 1);
            notifySuccess(t("resourcetypes.toast_resourcetype_updated"))
        });
        handleUpdate();
    };

    function handleDeleteResourcetype() {
        axios.delete(
            "/api/resourcetypes/" + deleteResourcetype["_id"],
            {},
            {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {

            if (res != undefined && res.status === 200) {
                notifySuccess(t("resourcetypes.toast_resourcetype_deleted"));
                setUpdateTable(updateTable + 1);
            }
            else {
                notifyWarning(t("resourcetypes.toast_resourcetype_in_use"))
            }
            handleCloseDeleteModal();

        }).catch(err => {
            if(err.message == "Request failed with status code 409"){
                notifyWarning(t("resourcetypes.toast_resourcetype_in_use"));
            }
        });
        handleUpdate();
    };


    useEffect(() => {
        if (auth.user["userdata"] == undefined) { window.location.href = "/login"; }
    }, []);

    const pageTableFields = {
        showFields: [
            { label: t("resourcetypes.name"), field: "name" },
            { label: t("resourcetypes.subtypes"), field: "resourceSubtypeReadable" }
        ]
    }


    return (
        <>

            <Card>
                <Accordion.Toggle className="clickable" as={Card.Header} eventKey="0">
                    <h4 className="header-title">{t("resourcetypes.page_name")}</h4>
                    <p>{t("resourcetypes.page_description")}</p>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                    <Card.Body>
                        <Button className="newresourcetypeBtn" onClick={handleShow}>{t("resourcetypes.new")}</Button>
                        <br />
                        <PageTable
                            dataUrl={"/api/resourcetypes/getAllPaged/"}
                            options={pageTableFields}
                            dataAfter={(dataLine) => <Button onClick={(evt) => handleShowDeleteModal(dataLine, evt)}>{t("resourcetypes.delete")}</Button>}
                            onLineClick={handleShowEditModal}
                            hidePagination={false}
                            hidePagesize={false}
                            hideFilter={false}
                            updateTable={updateTable}
                            hover={true}
                        />
                    </Card.Body>
                </Accordion.Collapse>
            </Card>

            {/* Creating modal */}
            <Modal show={show} onHide={handleClose} >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("resourcetypes.new_title")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Field
                        type="input"
                        title={t("resourcetypes.new_name")}
                        value={newName}
                        onChange={value => setNewName(value)}
                        placeholder={t("resourcetypes.new_name")}
                    ></Field>
                    <Field
                        type="textarea"
                        title={t("resourcetypes.new_subtypes")}
                        value={newResourceSubType.length != 0 ? newResourceSubType.reduce((a, b) => { return a + (b != "" ? ("\n" + b) : "\n") }) : ""}
                        onChange={value => updateNewSubtypes(value)}
                    ></Field>
                    <hr/>
                    <p>{t("resourcetypes.auto_generate_description")}</p>
                    <Field
                        type="checkbox"
                        title={t("resourcetypes.auto_generate_timeline")}
                        value={newAutoGenerateTimeline}
                        onChange={val => setAutoGenerateTimeline(val)}
                    />
                    <hr/>
                    <h3 style={{fontSize: "18px"}}>{t("resourcetypes.prop_title")}</h3>
                    {
                        newDefaultProps != undefined ? newDefaultProps.map((item, key) =>
                            <div className="propContainer row" key={key} >
                                <div className="col col-sm-5">
                                    <Field
                                        type="input"
                                        title={t("resourcetypes.prop_name")}
                                        value={item["name"]}
                                        onChange={(val) => { handleNewPropName(val, key) }} ></Field>
                                </div>
                                <div className="col col-sm-5">
                                    <Field
                                        type="input"
                                        title={t("resourcetypes.prop_value")}
                                        value={item["value"]}
                                        onChange={(val) => { handleNewPropValue(val, key) }} ></Field>
                                </div>
                                <div className="col-sm-2">
                                    <Button onClick={() => deleteProp(key)}>{t("resourcetypes.prop_delete")}</Button>
                                </div>
                            </div>
                        )
                            : null
                    }
                    <Button onClick={addProp}>{t("resourcetypes.prop_add")}</Button>
                    <hr/>
                    <h3 style={{fontSize: "18px"}}>{t("resourcetypes.cleaning_rules_title")}</h3>
                    <Field
                        type="selectmulti"
                        title={t("resourcetypes.cleaning_rules.field")}
                        value={availableMaintenanceRules.filter(i => newMaintenanceRules.includes(i.value))}
                        options={{
                            choosetext: t("resourcetypes.cleaning_rules.choosetext"),
                            choices: availableMaintenanceRules
                        }}
                        onChange={(val) => { setNewMaintenanceRules(val.map(i => i.value)) }}
                    ></Field>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleClose}>
                        {t("resourcetypes.cancel_without_save")}
                    </Button>
                    <Button onClick={handleCreateResource}>
                        {t("resourcetypes.save")}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Editing modal */}
            <Modal show={showEditModal} onHide={handleCloseEditModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("resourcetypes.resourcetype_edit")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Field
                        type="input"
                        title={t("resourcetypes.new_name")}
                        value={editResourcetype["name"]}
                        onChange={val => setEditResourcetypeName(val)}
                    ></Field>
                    <Field
                        type="textarea"
                        title={t("resourcetypes.new_subtypes")}
                        value={editResourcetype["resourceSubtype"].length != 0 ? editResourcetype["resourceSubtype"].reduce((a, b) => { return a + (b != "" ? ("\n" + b) : "\n") }) : ""}
                        onChange={value => updateEditSubtypes(value)}
                    ></Field>
                    <hr/>
                    <p>{t("resourcetypes.auto_generate_description")}</p>
                    <Field
                        type="checkbox"
                        title={t("resourcetypes.auto_generate_timeline")}
                        value={editResourcetype["autoGenerateTimeline"]}
                        onChange={val => setEditAutoGenerateTimeline(val)}
                        checked={editResourcetype["autoGenerateTimeline"] != undefined ? editResourcetype["autoGenerateTimeline"] : false}
                    />
                    <hr/>
                    <h3 style={{fontSize: "18px"}}>{t("resourcetypes.prop_title")}</h3>
                    {
                        editResourcetype["defaultProps"] != undefined ? editResourcetype["defaultProps"].map((item, key) =>
                            <div className="propContainer row" key={key} >
                                <div className="col col-sm-5">
                                    <Field
                                        type="input"
                                        title={t("resourcetypes.prop_name")}
                                        value={item["name"]}
                                        onChange={(val) => { handleEditPropName(val, key) }} ></Field>
                                </div>
                                <div className="col col-sm-5">
                                    <Field
                                        type="input"
                                        title={t("resourcetypes.prop_value")}
                                        value={item["value"]}
                                        onChange={(val) => { handleEditPropValue(val, key) }} ></Field>
                                </div>
                                <div className="col-sm-2">
                                    <Button onClick={() => deleteEditProp(key)}>{t("resourcetypes.prop_delete")}</Button>
                                </div>
                            </div>
                        )
                            : null
                    }
                    <Button onClick={addEditProp}>{t("resourcetypes.prop_add")}</Button>
                    <hr/>
                    <h3 style={{fontSize: "18px"}}>{t("resourcetypes.cleaning_rules_title")}</h3>
                    <Field
                        type="selectmulti"
                        title={t("resourcetypes.cleaning_rules.field")}
                        value={editResourcetype["maintenanceRules"] != undefined ? availableMaintenanceRules.filter(i => editResourcetype["maintenanceRules"].includes(i.value)) : []}
                        options={{
                            choosetext: t("resourcetypes.cleaning_rules.choosetext"),
                            choices: availableMaintenanceRules
                        }}
                        onChange={(val) => { setEditResourcetypeMaintenanceRules(val.map(i => i.value)) }}
                    ></Field>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseEditModal}>
                        {t("resourcetypes.cancel_without_save")}
                    </Button>
                    <Button onClick={handleEditResourcetype}>
                        {t("resourcetypes.save")}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Modal */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("resourcetypes.delete_resourcetype")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t("resourcetypes.delete_info")}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseDeleteModal}>
                        {t("resourcetypes.cancel")}
                    </Button>
                    <Button onClick={handleDeleteResourcetype}>
                        {t("resourcetypes.delete_resourcetype")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default ResourceTypes;